import Intro from "./Intro/Intro";
import "./Content.css"
import Map from "./map/Map";
import MapLegend from "./Legend/MapLegend";
import Popup from "./popup/Popup"
import { useContext } from "react";
import { MapContext } from "../../context/MapContext";

export default function Content () {
  const { mode } = useContext(MapContext);
  return (
    <div className="Content">
      <div className="zoomTooltip">
				격자를 클릭하면 해당 격자의 정보를 확인할 수 있습니다.
			</div>
      <div className="mapOptionModalWrap">
        <MapLegend />
      </div>
      <Popup />
      <Map />
      {mode === 'intro' ? <Intro /> : null}
    </div>
  )
};